export default __webpack_public_path__ + "static/media/cycling.926fa9dd.jpg";